


























import {Component, Prop, Vue} from 'vue-property-decorator'
import {Game} from "@/models/Game";

@Component
export default class RoundLogic extends Vue {

    @Prop()
    game: Game;

    @Prop()
    activePlayer: string;

    @Prop()
    activeRound: number;

    @Prop()
    playerIndex: number;

    @Prop()
    guess: boolean;

    @Prop()
    guessCounter: number;

    @Prop()
    actualCounter: number;


    get showBackButton() {
        return this.playerIndex !== 0;
    }

    private playerMove(chosenValue: number) {
        if (this.guess) {
            this.handleGuess(chosenValue);
        } else {
            this.handleActual(chosenValue);
        }
        this.checkIfGameIsOver();
        this.updateGame();
    }

    private checkIfGameIsOver() {
        if (!this.guess && this.activeRound === (60 / this.game.numberOfPlayers) && this.playerIndex === this.game.numberOfPlayers-1) {
            this.$emit('end-game');
        }
    }

    private deleteLastMove() {
        this.$emit('decrease-player-index')
    }

    private handleGuess(chosenValue: number) {
        this.$emit('set-guess', chosenValue);
        if (this.playerIndex === this.game.numberOfPlayers-1) {
            this.$emit('change-to-actuals');
        } else {
            this.$emit('increase-player-index');
        }
    }

    private handleActual(chosenValue: number) {
        this.$emit('set-actual', chosenValue);
        if (this.playerIndex === this.game.numberOfPlayers-1) {
            this.checkIfGameIsOver();
            this.$emit('create-next-round');
        } else {
            this.$emit('increase-player-index');
        }
    }

    private updateGame() {
        this.$emit('update-game');
    }
}
